import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "grid-tab-container" }
const _hoisted_2 = { class: "dashboard-stats" }
const _hoisted_3 = { class: "stat-card" }
const _hoisted_4 = { class: "stat-content" }
const _hoisted_5 = { class: "stat-value" }
const _hoisted_6 = { class: "stat-card" }
const _hoisted_7 = { class: "stat-content" }
const _hoisted_8 = { class: "stat-value" }
const _hoisted_9 = { class: "stat-card" }
const _hoisted_10 = { class: "stat-content" }
const _hoisted_11 = { class: "stat-value" }
const _hoisted_12 = { class: "stat-card" }
const _hoisted_13 = { class: "stat-content" }
const _hoisted_14 = { class: "stat-value" }
const _hoisted_15 = {
  key: 0,
  class: "currency-cell"
}
const _hoisted_16 = { class: "currency-value" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "status-cell" }
const _hoisted_19 = { class: "popup-body-modern" }
const _hoisted_20 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_21 = {
  class: "dropdown-grid-container",
  style: {"height":"300px"}
}
const _hoisted_22 = { class: "form-footer footer-modern" }
const _hoisted_23 = { class: "footer-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxExport = _resolveComponent("DxExport")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxGridToolbarItem = _resolveComponent("DxGridToolbarItem")!
  const _component_DxGridToolbar = _resolveComponent("DxGridToolbar")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxFormItem = _resolveComponent("DxFormItem")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxDropDownBox = _resolveComponent("DxDropDownBox")!
  const _component_DxLabel = _resolveComponent("DxLabel")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "stat-icon",
          style: {"background":"#dbeafe"}
        }, [
          _createElementVNode("i", {
            class: "dx-icon-box",
            style: {"color":"#1e40af"}
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "stat-label" }, "Total Campanii", -1)),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.totalCampaigns), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "stat-icon",
          style: {"background":"#d1fae5"}
        }, [
          _createElementVNode("i", {
            class: "dx-icon-event",
            style: {"color":"#065f46"}
          })
        ], -1)),
        _createElementVNode("div", _hoisted_7, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "stat-label" }, "Campanii Active", -1)),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.activeCampaigns), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[9] || (_cache[9] = _createElementVNode("div", {
          class: "stat-icon",
          style: {"background":"#fef3c7"}
        }, [
          _createElementVNode("i", {
            class: "dx-icon-money",
            style: {"color":"#78350f"}
          })
        ], -1)),
        _createElementVNode("div", _hoisted_10, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "stat-label" }, "Buget Total", -1)),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatCurrency(_ctx.totalBudget)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[11] || (_cache[11] = _createElementVNode("div", {
          class: "stat-icon",
          style: {"background":"#fed7aa"}
        }, [
          _createElementVNode("i", {
            class: "dx-icon-chart",
            style: {"color":"#92400e"}
          })
        ], -1)),
        _createElementVNode("div", _hoisted_13, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "stat-label" }, "Media Buget", -1)),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.formatCurrency(_ctx.averageBudget)), 1)
        ])
      ])
    ]),
    _createVNode(_component_DxDataGrid, {
      ref: "dataGrid",
      allowColumnReordering: true,
      "data-source": _ctx.dsCampaniiMarketing,
      allowColumnResizing: true,
      "key-expr": "ID",
      columnAutoWidth: false,
      columnResizingMode: 'nextColumn',
      "show-borders": true,
      syncLookupFilterValues: false,
      "filter-sync-enabled": true,
      "show-column-lines": false,
      "hover-state-enabled": true,
      "remote-operations": true,
      class: "grid theme-dependent",
      onRowClick: _ctx.onRowClick
    }, {
      budgetTemplate: _withCtx(({ data }) => [
        (data.value !== null && data.value !== undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formatCurrency(data.value)), 1)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_17, "-"))
      ]),
      activeTemplate: _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", {
            class: _normalizeClass(['status-badge', data.value ? 'status-active' : 'status-inactive'])
          }, [
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "status-dot" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(data.value ? 'Activ' : 'Inactiv'), 1)
          ], 2)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxPaging, {
          "page-size": 15,
          "page-index": 1
        }),
        _createVNode(_component_DxColumnChooser, { enabled: true }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxHeaderFilter, { visible: false }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          placeholder: "Caută campanie..."
        }),
        _createVNode(_component_DxExport, {
          enabled: true,
          "allow-export-selected-data": true,
          formats: ['xlsx', 'pdf']
        }),
        _createVNode(_component_DxGridToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "plus",
                  type: "success",
                  onClick: _ctx.onAddClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, {
              location: "after",
              "locate-in-menu": "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "refresh",
                  onClick: _ctx.onRefreshClick,
                  hint: "Reîmprospătează"
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, { name: "exportButton" }),
            _createVNode(_component_DxGridToolbarItem, { name: "columnChooserButton" }),
            _createVNode(_component_DxGridToolbarItem, { name: "searchPanel" })
          ]),
          _: 1
        }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxColumn, { "data-field": "Denumire" }),
        _createVNode(_component_DxColumn, {
          "data-field": "IndustrieNume",
          caption: "Industrie"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "StatusNume",
          caption: "Status"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "TipCampanieNume",
          caption: "Tip Campanie"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataStart",
          caption: "Dată Start",
          "data-type": "date",
          format: "dd/MM/yyyy"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "DataEnd",
          caption: "Dată End",
          "data-type": "date",
          format: "dd/MM/yyyy"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Buget",
          "data-type": "number",
          format: "#,##0.00",
          "cell-template": "budgetTemplate"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CurentActiv",
          caption: "Activ",
          "cell-template": "activeTemplate"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Explicatie",
          visible: false
        })
      ]),
      _: 1
    }, 8, ["data-source", "onRowClick"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isModalVisible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isModalVisible) = $event)),
      closeOnOutsideClick: false,
      showCloseButton: false,
      showTitle: true,
      width: 700,
      height: 500
    }, {
      title: _withCtx(() => [...(_cache[13] || (_cache[13] = [
        _createElementVNode("div", { class: "popup-header" }, [
          _createElementVNode("div", { class: "popup-header-main" }, [
            _createElementVNode("span", { class: "popup-header-icon dx-icon-add" }),
            _createElementVNode("div", { class: "popup-header-texts" }, [
              _createElementVNode("div", { class: "popup-header-title" }, "Adăugare campanie"),
              _createElementVNode("div", { class: "popup-header-subtitle" }, " Completează informațiile în pașii de mai jos ")
            ])
          ]),
          _createElementVNode("div", { class: "popup-header-meta" }, [
            _createElementVNode("span", { class: "status-chip status-chip--draft" }, " Nouă ")
          ])
        ], -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_DxForm, {
            "form-data": _ctx.formData,
            "col-count": 3,
            ref: "form"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxFormItem, {
                "data-field": "Denumire",
                "col-span": 3
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxRequiredRule, { message: "Denumirea este obligatorie" })
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, { label: { text: 'Industrie' } }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxDropDownBox, {
                    value: _ctx.sIndustrie,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sIndustrie) = $event)),
                    "data-source": _ctx.dsIndustrii,
                    "display-expr": "Nume",
                    "value-expr": "ID",
                    "show-clear-button": true,
                    placeholder: "Selectează ",
                    "content-template": "gridContent"
                  }, {
                    gridContent: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_DxDataGrid, {
                          "data-source": _ctx.dsIndustrii,
                          columns: ['Nume'],
                          "hover-state-enabled": true,
                          height: 280,
                          "remote-operations": true,
                          onRowClick: _ctx.onIndustrieRowClick
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxPaging, {
                              enabled: true,
                              "page-size": 5
                            }),
                            _createVNode(_component_DxFilterRow, { visible: true }),
                            _createVNode(_component_DxScrolling, { mode: "virtual" })
                          ]),
                          _: 1
                        }, 8, ["data-source", "onRowClick"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["value", "data-source"])
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, { label: { text: 'Tip Campanie' } }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxDropDownBox, {
                    value: _ctx.sTipCampanie,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sTipCampanie) = $event)),
                    "data-source": _ctx.dsTipuriCampanii,
                    "display-expr": "Denumire",
                    "value-expr": "ID",
                    "show-clear-button": true,
                    placeholder: "Selectează ",
                    "content-template": "gridContent"
                  }, {
                    gridContent: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_DxDataGrid, {
                          "data-source": _ctx.dsTipuriCampanii,
                          columns: ['Denumire'],
                          "hover-state-enabled": true,
                          height: 280,
                          "remote-operations": true,
                          onRowClick: _ctx.onTipCampanieRowClick
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DxPaging, {
                              enabled: true,
                              "page-size": 5
                            }),
                            _createVNode(_component_DxFilterRow, { visible: true }),
                            _createVNode(_component_DxScrolling, { mode: "virtual" })
                          ]),
                          _: 1
                        }, 8, ["data-source", "onRowClick"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["value", "data-source"])
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormItem, {
                "data-field": "Buget",
                "editor-type": "dxNumberBox",
                "editor-options": _ctx.bugetEditorOptions
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxRequiredRule, { message: "Bugetul este obligatoriu" })
                ]),
                _: 1
              }, 8, ["editor-options"]),
              _createVNode(_component_DxFormItem, {
                "data-field": "DataStart",
                "editor-type": "dxDateBox",
                "editor-options": _ctx.dateEditorOptions
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxRequiredRule, { message: "Data de start este obligatorie" })
                ]),
                _: 1
              }, 8, ["editor-options"]),
              _createVNode(_component_DxFormItem, {
                "data-field": "DataEnd",
                "editor-type": "dxDateBox",
                "editor-options": _ctx.dateEditorOptions
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxRequiredRule, { message: "Data de sfârșit este obligatorie" })
                ]),
                _: 1
              }, 8, ["editor-options"]),
              _createVNode(_component_DxFormItem, {
                "data-field": "StatusID",
                "editor-type": "dxSelectBox",
                label: { text: 'Nou' },
                "editor-options": {
                            dataSource: _ctx.dsStatusuri,
                            displayExpr: 'Nume',
                            valueExpr: 'ID',
                            readOnly: true,
                            hoverStateEnabled: false,
                            placeholder: 'Nou'
                        }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxLabel, { text: "Status Campanie" })
                ]),
                _: 1
              }, 8, ["editor-options"]),
              _createVNode(_component_DxFormItem, {
                "data-field": "Explicatie",
                "editor-type": "dxTextArea",
                "col-span": 3,
                "editor-options": _ctx.explicatieEditorOptions
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxLabel, { text: "Explicație" })
                ]),
                _: 1
              }, 8, ["editor-options"])
            ]),
            _: 1
          }, 8, ["form-data"]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "success",
                onClick: _ctx.onSaveAdd,
                "styling-mode": "outlined",
                width: "100",
                height: "32"
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Anulează",
                type: "danger",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isModalVisible = false)),
                "styling-mode": "outlined",
                width: "100",
                height: "32"
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}